import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import './App.css';
import Footer from './Component/Footer';
import Contact_Component from './Component/Contact_Component';
import Main_Navbar from './Component/Main_Navbar';
import About_us from './Page/About_us';
import Campus_Ambassador from './Component/Campus_Ambassador';
import Our_program from './Page/Our_program';
import BDA_job from './Component/BDA_job';
import Advance_program_page from './Page/Advance_program_page';
import ML_page from './Component/Machine_learning/ML_page';
import WD_page from './Component/Wed_Development/WD_page'
import DS_page from './Component/Data_Science/DS_page';
import CS_page from './Component/Cyber Security/CS_page';
import AI_page from './Component/Artificial Intelligence/AI_page';
import CC_page from './Component/Cloud Computing/CC_page';
import AAD_page from './Component/Android App Development/AAD_page';
import RO_page from './Component/Robotics/RO_page';
import AC_page from './Component/AutoCAD/AC_page';
import HR_page from './Component/Human Resource/HR_page';
import FA_page from './Component/Finance/FA_page';
import BA_page from './Component/Business Analytics/BA_page';
import DM_page from './Component/Digital Marketing/DM_page';
import Java_page from './Component/Java/Java_page';
import PY_page from './Component/Python/PY_page'
import DMM_page from './Component/Digital Marketing & Marketing/DMM_page';
import FSW_page from './Component/Full Stack Web/FSW_page';
import MS_page from './Component/MS Course/MS_page';
import CCD_page from './Component/C, C++ with DSA/CCD_page';
import Main_Home_page from './Page/Main_Home_page';
import Contact_page from './Page/Contact_page';
import Student_Register_form from './Page/Student_Register_form';
import Terms_page from './Page/Terms_page';
import Not_Found from './Page/Not_Found';
import Terms_and_Conditions from './Page/Terms_and_Conditions';
import ScrollToTop from './Component/ScrollToTop';
import Mobile_program from './Component/Mobile_program';
import Mobile_career from './Component/Mobile_career';
import VLSI_page from './Component/VLSI/VLSI_page'
import IOT_page from './Component/IOT/IOT_page'
import ES_page from './Component/Embedded System/ES_page';
import Blog_page from './Page/Blog_page';
import Blog_page_content from "./Component/Blog_page_content";
import Blog_page_content1 from "./Component/Blog_page_content1";
import Blog_page_content2 from "./Component/Blog_page_content2";
import Blog_page_content3 from "./Component/Blog_page_content3";
import Blog_page_content4 from "./Component/Blog_page_content4";
import Font_page from "./Page/Font_page";
import Combo_page from "./Page/Combo_page";
import Runing_bar from "./Component/Runing_bar";
import Coding_camp from "./Component/Coding_camp";
function App() {
  return (

    <>
    <HelmetProvider>
    <Router>
    <div className="App">
    <ScrollToTop/>
    <Main_Navbar/>
      <Routes>
      <Route path="/" element={<Main_Home_page/>}/>
      <Route path="/About-Internselite" element={<About_us/>}/>
      <Route path="/Blog" element={<Blog_page/>}/>
      <Route path='/Best-Online-Courses-Internselite' element={<Blog_page_content/>}/> 
      <Route path='/Online-Internship' element={<Blog_page_content1/>}/> 
      <Route path='/Courses-From-IIT' element={<Blog_page_content2/>}/> 
      <Route path='/Elevate-Your-Career-With-Professional-Courses' element={<Blog_page_content3/>}/> 
      <Route path='/The-Power-Of-Online-Training' element={<Blog_page_content4/>}/> 
      <Route path='/Privacy-Policy/Refund-Policy' element={<Terms_page/>}/>
      <Route path='/Terms-and-Conditions' element={<Terms_and_Conditions/>}/>
      <Route path="/Contact-Us" element={<Contact_page/>}/>
      <Route path="/Traineeship-Program" element={<Our_program/>}/>
      <Route path="/Advance-Program" element={<Advance_program_page/>}/>
      <Route path="/Double-Program" element={<Combo_page/>}/>
      <Route path="/Coding-Skill-Program" element={<Coding_camp/>}/>
      <Route path="/Campus-Ambassador-Program" element={<Campus_Ambassador/>}/>
      <Route path="/Business-Development-Associate" element={<BDA_job/>}/>
      <Route path="/Contact" element={<Contact_Component/>}/>
      <Route path="/Artificial-Intelligence" element={<AI_page/>}/>
      <Route path="/Machine-Learning" element={<ML_page/>}/>
      <Route path="/Web-Development" element={<WD_page/>}/>
      <Route path="/Data-Science" element={<DS_page/>}/>
      <Route path="/Android-App-Development" element={<AAD_page/>}/>
      <Route path="/Robotics" element={<RO_page/>}/>
      <Route path="/Cyber-Security" element={<CS_page/>}/>
      <Route path="/Cloud-Computing" element={<CC_page/>}/>
      <Route path="/Human-Resources" element={<HR_page/>}/>
      <Route path="/Finance" element={<FA_page/>}/>
      <Route path="/Business-Analytics" element={<BA_page/> }/>
      <Route path="/Autocad" element={<AC_page/>}/>
      <Route path="/Digital-Marketing" element={<DM_page/> }/>
      <Route path="/Java-Programming" element={<Java_page/>}/>
      <Route path="/Python-Programming" element={<PY_page/>}/>
      <Route path="/Digital-Marketing-and-Marketing" element={<DMM_page/>}/>
      <Route path="/Full-Stack-Web-Development" element={<FSW_page/>}/>
      <Route path='/Mern-Stack-Development' element={<MS_page/>}/>
      <Route path="/C-CPP-DSA" element={<CCD_page/>}/>
      <Route path="/Vlsi-Design" element={<VLSI_page/>}/>
      <Route path="/Internet-of-Things" element={<IOT_page/>}/>
      <Route path="/Embedded-System" element={<ES_page/>}/>
      <Route path='/Student-Register' element={<Student_Register_form/>}/> 
      <Route path='/Training-Programs' element={<Mobile_program/>}/> 
      <Route path='/Careers' element={<Mobile_career/>}/> 
      <Route path='/Font' element={<Font_page/>}/> 
      <Route path='*' element={<Not_Found/>}/> 
      </Routes>
      <Footer/>
    </div>
    </Router>
    </HelmetProvider> 
    </>

    
    
   
  );
}

export default App;
